import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils/A11y';
import { Payment } from './Payment';
import { PaymentAmount } from './PaymentAmount';
import { AutoTopupInitialization } from './AutoTopupInitialization';
import { HowItWorks } from './HowItWorks';
import { Meta } from '@core/Meta';
import { keyValueValidation } from '@utils/globalConstant';
import { useTitle } from '@context/Utils/Title';
export function ActivationStep9() {
  // Context
  const { step9SubStep, setShowActivationFooter, setShowActivationHeader } = useActivation();
  const { tA11yTranslate, getGlobalMetaTitles } = useA11y();
  const { announceTitle } = useTitle();
  // META: page titles
  const { globalPageTitle } = getGlobalMetaTitles();
  const activationRegTopUpPageTitle = tA11yTranslate('ek_global_meta_title_reg_top_up').content;
  const activationRegTopUpDetailsPageTitle = tA11yTranslate('ek_global_meta_title_reg_top_up_details').content;
  const activationRegTopUpChooseAmountPageTitle = tA11yTranslate('ek_global_meta_title_reg_top_up_choose_amount').content;
  const activationRegTopUpPaymentPageTitle = tA11yTranslate('ek_global_meta_title_reg_top_up_payment').content;
  
  const isTranslationReady = keyValueValidation(
    activationRegTopUpPageTitle,
    'ek_global_meta_title_reg_top_up'
  );

  useEffect(() => {
    setShowActivationFooter(true);
    setShowActivationHeader(true);

    if (step9SubStep === 1) {
      setShowActivationFooter(false);
      setShowActivationHeader(false);
    }
  }, [step9SubStep]);

  // Determine the page title based on the current substep
  const getPageTitle = () => {
    if (step9SubStep === 1) {
      return `${globalPageTitle} - ${activationRegTopUpDetailsPageTitle}`;
    } else if(step9SubStep === 2){
      return `${globalPageTitle} - ${activationRegTopUpChooseAmountPageTitle}`;
    } else if(step9SubStep === 3){
      return `${globalPageTitle} - ${activationRegTopUpPaymentPageTitle}`;
    } else{
      return `${globalPageTitle} - ${activationRegTopUpPageTitle}`;
    }
  };

  useEffect(() => {
    const pageTitle = `${getPageTitle()}`;
    announceTitle(pageTitle);
  }, [step9SubStep, announceTitle]); // Re-run when substep changes

  const renderStep9SubSteps = (subStep) => {
    switch (subStep) {
      case 0:
        return <AutoTopupInitialization />;
      case 1:
        return <HowItWorks />;
      case 2:
        return <PaymentAmount />;
      case 3:
        return <Payment />;
      default:
        return <AutoTopupInitialization />;
    }
  };

  return (
    <>
      <Meta title={getPageTitle()} key={`meta-key-${step9SubStep}`} />
      {renderStep9SubSteps(step9SubStep)}
    </>
  );
}

export default ActivationStep9;
